import React from 'react';
import { FeedbackFranchise } from '../FeedbackSlider/FeedbackSlider';
import styled from 'styled-components';
import nav from '../../assets/icons/nav.svg';

const FeedbackSlide = ({ name, address, logo, text }: FeedbackFranchise) => {
  return (
    <Slide>
      <SlideHeader>
        <img src={logo} alt="logo" />
        <SlideInfo>
          <span>{name}</span>
          <SlideInfoBtn>
            <img src={nav} alt="location" />
            <span>{address}</span>
          </SlideInfoBtn>
        </SlideInfo>
      </SlideHeader>
      <SlideComments>
        {text.map((paragraph, i) => (
          <p key={i}>{paragraph}</p>
        ))}
      </SlideComments>
    </Slide>
  );
};

const Slide = styled.div`
  padding: 26px 29px;
  border: 2px solid #e7e8eb;
  border-radius: 12px;
  cursor: pointer;
  height: 100%;
`;

const SlideHeader = styled.div`
  display: flex;
  gap: 16px;
  align-items: center;
  & img {
    border: 1px solid #e7e8eb;
    border-radius: 100px;
    width: 65px;
    height: 65px;
    object-fit: cover;
  }
`;

const SlideInfo = styled.div`
  display: flex;
  flex-direction: column;
  & span {
    font-weight: 700;
    font-size: 20px;
    color: #606872;
  }
`;

const SlideInfoBtn = styled.button`
  background: transparent;
  display: flex;
  gap: 10px;
  margin-top: 5px;
  & span {
    font-weight: 400;
    font-size: 18px;
  }
  & img {
    width: 14px;
    height: 20px;
    border: none;
  }
`;

const SlideComments = styled.div`
  display: flex;
  flex-direction: column;
  font-size: 16px;
  line-height: 24px;
  margin-top: 24px;
  & p {
    &:last-child {
      margin-bottom: 0;
    }
  }
`;

export default FeedbackSlide;
